<script setup lang="ts">
withDefaults(
  defineProps<{
    position?: string
    hasCaret?: boolean
    hasShadow?: boolean
    isRounded?: boolean
    caretColor?: string
    topColor?: string
    bottomColor?: string
    backgroundColor?: string
  }>(),
  {
    position: null,
    hasCaret: false,
    hasShadow: true,
    isRounded: true,
    caretColor: 'border-b-pink-400',
    topColor: 'bg-pink-400',
    bottomColor: 'bg-yellow-400',
    backgroundColor: 'bg-white'
  }
)
</script>

<template>
  <div :class="position" class="relative">
    <div :class="`w-full ${isRounded ? 'rounded-md' : 'rounded-t-md'} overflow-hidden ${hasShadow ? 'shadow' : ''}`">
      <div class="relative" :class="`${backgroundColor} px-4 py-0 ${isRounded ? 'rounded-md' : 'rounded-t-md'}`">
        <div class="relative z-10">
          <slot />
        </div>
        <div
          :class="`absolute -right-10 bottom-3/4 ${topColor} w-1/2 aspect-square rounded-full blur-2xl opacity-60`"
        />
        <div
          :class="`absolute  ${bottomColor} w-2/4 aspect-square -left-14 top-2/3  rounded-full blur-2xl opacity-50`"
        />
      </div>
    </div>
    <div
      v-if="hasCaret"
      :class="`z-10 hidden absolute -top-4 right-24 w-0 h-0 border-8 border-solid border-transparent opacity-50 ${caretColor} sm:opacity-40 sm:block lg:right-14`"
    />
  </div>
</template>
